import type { StateCreator } from "zustand";
import { create } from "zustand";
import { type DevtoolsOptions, devtools } from "zustand/middleware";
import type { ShareVoiceSidebarFilter } from "@/data-access/share-of-voice/queries/shareOfVoice-sidebar-filter-queries";

export type SidebarFiltersDataFetchSlice = {
  isFetchingSidebarFilters: boolean;
  sidebarFilters: (ShareVoiceSidebarFilter[0] & {
    isLoadingCountAndPercentage: boolean;
  })[];
};

export type ShareOfVoiceSidebarFiltersSlice = SidebarFiltersDataFetchSlice;

const createShareOfVoiceFilterSlice: StateCreator<
  ShareOfVoiceSidebarFiltersSlice
> = () => ({
  /** data fetch initial state */
  isFetchingSidebarFilters: false,
  sidebarFilters: [],
});

const useShareOfVoiceSidebarFilters = create<ShareOfVoiceSidebarFiltersSlice>()(
  devtools(createShareOfVoiceFilterSlice, {
    name: "sov-filter-store",
    serialize: {
      options: true,
    },
  } satisfies DevtoolsOptions),
);

export default useShareOfVoiceSidebarFilters;
